/**
 * GraphQL AWSJSON fields may deserialize as either a JSON string or a plain object.
 */
export type AnnotationPolygonPayload = {
  annotations?: number[][];
};

export function parseAnnotationPolygon(
  polygon: unknown
): AnnotationPolygonPayload | null {
  if (polygon == null || polygon === "") {
    return null;
  }

  if (typeof polygon === "string") {
    try {
      const parsed = JSON.parse(polygon) as unknown;

      if (parsed && typeof parsed === "object") {
        return parsed as AnnotationPolygonPayload;
      }

      return null;
    } catch {
      return null;
    }
  }

  if (typeof polygon === "object") {
    return polygon as AnnotationPolygonPayload;
  }

  return null;
}
